/**
 * Load Cloud Family Tool
 *
 * Cloud-library counterpart of Load Family. The offline build ships a
 * curated in-session catalog instead of querying external web services; the
 * picked schema registers through the same FamilyLoader path as local files,
 * so placed components behave identically.
 */

import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import { CLOUD_FAMILY_CATALOG } from '../data/cloudFamilyCatalog';
import { FamilySchema } from '../core/families/FamilySchema';
import { familyLoader } from '../core/services';
import i18n from '../i18n';

/** Catalog exposed to the picker dialog (shared singleton list). */
export function getCloudFamilyCatalog(): FamilySchema[] {
    return CLOUD_FAMILY_CATALOG;
}

export class LoadCloudFamilyTool extends BaseTool {
    id = 'load_cloud_family';
    name = 'Load Cloud Family';
    cursor = 'default';

    onActivate(): void {
        // Dialog-driven command: open the cloud family browser. The dialog
        // lives in the UI layer and calls loadCatalogFamily() on selection.
        this.context?.appStore.openManageDialog('cloudFamily');
        this.context?.appStore.setActiveTool('select');
    }

    /** Load one catalog schema; returns success so the dialog can report. */
    public async loadCatalogFamily(schema: FamilySchema): Promise<boolean> {
        try {
            await familyLoader.loadFamily(schema);
            this.notify(i18n.t('tools.notify.familyDownloaded', { name: schema.name }), 'success');
            return true;
        } catch (err) {
            this.notify(i18n.t('tools.notify.familyDownloadFailed', { error: String(err) }), 'error');
            return false;
        }
    }

    onPointerDown(_event: ThreeEvent<PointerEvent>): void { }
    onPointerMove(_event: ThreeEvent<PointerEvent>): void { }
    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }
}
